var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.holderWidth }, [
    _c(
      "a",
      {
        staticClass: "article-item",
        attrs: { href: _vm.href, target: _vm.target ? "_blank" : "" },
      },
      [
        _c(
          "div",
          { staticClass: "article-item-image", class: _vm.pictureHeight },
          [
            _c("img", { staticClass: "img-cover", attrs: { src: _vm.imgSrc } }),
            _vm._v(" "),
            _vm.isVideo
              ? _c(
                  "div",
                  { staticClass: "article-item-play abs-center icon" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/sprite/svg/close.svg?raw"),
                        alt: "",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pt-15" }, [
          _vm.section || _vm.date
            ? _c("div", { staticClass: "mb-10 d-flex color-grey4 text-h4" }, [
                _c("span", {
                  staticClass: "mr-10",
                  domProps: { innerHTML: _vm._s(_vm.section) },
                }),
                _vm._v(" "),
                _c("span", { domProps: { innerHTML: _vm._s(_vm.date) } }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "text-h5 mb-5",
            domProps: { innerHTML: _vm._s(_vm.title) },
          }),
          _vm._v(" "),
          _vm.lead
            ? _c("div", {
                staticClass: "color-grey4",
                domProps: { innerHTML: _vm._s(_vm.lead) },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.link && _vm.linkText
            ? _c("div", { staticClass: "mt-10 text-t_sm" }, [
                _c("span", {
                  staticClass: "link link--black_border",
                  domProps: { innerHTML: _vm._s(_vm.linkText) },
                }),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }